export default {
    detailModule: {
        deadline: 'Application deadline',
        location: 'Location',
        employmentType: 'Employment type',
        languageRequirements: 'Language requirements',
        workPermitRequirements: 'Work permit requirements',
        preferredEducationField: 'Preferred education field',
        preferredEducationLevel: 'Preferred education level',
        jobTags: 'Tags',
        apply: 'Apply now',
        verificationRequired: 'You need to verify your school e-mail to apply.',
        verificationRequiredHint: 'You need to verify your school e-mail to apply',
        verificationPending: 'You have a pending verification at this school',
        verificationPendingHint: 'You have a pending verification at this school',
        startDate: 'Start date',
    },

    profile: {
        headerApply: 'Required Profile Fields',
        applyDescription:
            'Complete the required profile fields to proceed to the job application. By completeing your profile it will help us to connect you with relevant job opportunities and events that best match your profile.',
    },

    errors: {
        applicationLink: {
            title: 'Error getting application link',
            message: 'Not able to get application link. Please try again later.',
        },
    },

    invalidJobAd: {
        caption:
            "Sorry, but we couldn't find this position. If you believe this is an error, please contact support using the chatbox below.",
        btn: 'Find other jobs',
    },
};
